import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import './HomePage.css';
import logo from '../assets/images/ilt_logo.png';
import avatar from '../assets/images/ilt_photo.png';
import bi from '../assets/images/bi.png';
import mm from '../assets/images/mm.png';
import matsci from '../assets/images/matsci.png';
import cf from '../assets/images/cf.png';
import s from '../assets/images/s.png';
import { Link } from 'react-router-dom'; 
import Footer from "../components/Footer.js";


const skills = [
  { title: 'Product Strategy & Vision', description: 'Define and execute long-term product strategies that align market opportunities, customer needs, and business objectives' },
  { title: 'Cross-Functional Leadership', description: 'Lead and inspire multidisciplinary teams across engineering, design, and marketing to deliver high-impact, outcome-driven products' },
  { title: 'Data-Driven Decision Making', description: 'Leverage analytics, experimentation, and user insights to guide prioritization, validate hypotheses, and measure success' },
  { title: 'Customer-Centric Innovation', description: 'Champion deep user understanding through JTBD and UX research, translating insights into products that solve real customer problems' },
  { title: 'Product Discovery and Delivery', description: 'Drive efficient product delivery through Agile and Lean methodologies, fostering continuous improvement and rapid iteration' },
];

const projects = [
  { id: 'project-bi_platform', title: 'Business Intelligence Platform', description: 'A centralized business intelligence system that transforms raw data into actionable insights', img: bi },
  { id: 'project-digital_content_platform', title: 'Digital Content Performance Platform', description: 'Tracks and analyzes digital content engagement to optimize marketing strategies', img: mm },
  { id: 'project-analytical_tools', title: 'Analytical Tools for Material Scientists', description: 'Software enabling material scientists to model, analyze, and interpret experimental data', img: matsci },
  { id: 'project-bi_dashboards', title: 'BI Dashboards for Franchise Operations', description: 'Interactive dashboards providing real-time operational and performance insights', img: s },
  { id: 'project-datasheets', title: 'Vehicle History<br />Datasheets', description: 'Comprehensive vehicle reports consolidating ownership, service, and accident history', img: cf },
];

const Carousel = ({ items, includeImages = false, className = "" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardWidth = 260; // width + margin

  const prev = () => setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
  const next = () => setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
console.log(Footer)
  return (
    <div className={`carousel-container ${className}`}>
      <button className="carousel-arrow left" onClick={prev}>&lt;</button>
      <div className="carousel-wrapper">
        <div
          className="carousel-track"
          style={{ transform: `translateX(-${currentIndex * cardWidth}px)` }}
        >
          {items.concat(items).map((item, idx) => (
            <div key={`${item.title}-${idx}`} className="carousel-card">
              {includeImages ? (
                <Link  to={`/projects#${item.id}`} className="carousel-card-link">
                  <div className="carousel-card-content">
                    <h3 dangerouslySetInnerHTML={{ __html: item.title }} />
                    <p>{item.description}</p>
                    {item.img && <img src={item.img} alt={item.title} className="carousel-image" />}
                  </div>
                </Link>
              ) : (
                <>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <button className="carousel-arrow right" onClick={next}>&gt;</button>
    </div>
  );
};

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Header */}
      <header className="header">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
        <nav className="nav">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#projects">Projects</a>
         <a href="/services">Services</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="section hero">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" className="avatar" />
        </div>
        <h1>Inga Linda Toma</h1>
        <p>
          Product leader with 15+ years in SaaS, B2B, and B2C, delivering enterprise-scale data platforms,
          dashboards, and analytical tools. Proven success in taking products from concept to market, building
          high-performing cross-functional teams, and aligning product strategy with business growth. Skilled
          in product discovery and product delivery, with a strong track record of measurable impact in global organizations.
        </p>
        <div className="hero-buttons">
          <a href="#projects" className="btn">View My Work</a>
          <a href="#contact" className="btn btn-secondary">Get In Touch</a>
        </div>
      </section>

      {/* About Me Section */}
      <section id="about" className="section about">
        <h2>About Me</h2>
        <p>
          I’m a product leader passionate about building high-performing teams and data-driven products that move
          the business forward. Over the past two decades, I’ve led global SaaS and analytics products from concept
          to scale— defining vision, building teams, and executing strategy that connects user value with business
          outcomes. <br />
          My leadership philosophy: give teams clarity, autonomy, and purpose— and the right ideas will thrive. <br />
          I bring together experience in product vision and strategy, UX research, analytics, and organizational
          design to create environments where great products— and people— grow.
        </p>
        <Carousel items={skills} className="skills-carousel" />
      </section>

      {/* Projects Section */}
      <section id="projects" className="section projects">
        <h2>Projects</h2>
        <Carousel items={projects} includeImages={true} className="projects-carousel" />
      </section>

      {/* Contact Section */}
      <section id="contact" className="section hero">
        <h2>Contact Me</h2>
        <p>
          LinkedIn:{' '}
          <a href="https://www.linkedin.com/in/ingalindatoma/" target="_blank" rel="noopener noreferrer">
            linkedin.com/in/ingalindatoma
          </a>
        </p>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;
